import { ArrayUtils, DateUtils } from '../../../utils'

/**
 * Format raw layer to the desired item
 * @param {Object} rawLayer
 */
const formatLayer = ({ date_end, date_start, date_upload_endend, date_upload_started, is_approved, ...layer }) => ({
    ...layer,
    date_end: date_start && DateUtils.UTCDateToTimestamp(date_end),
    date_start: date_start && DateUtils.UTCDateToTimestamp(date_start),
    date_upload_endend: date_upload_endend && DateUtils.UTCDateToTimestamp(date_upload_endend),
    date_upload_started: date_upload_started && DateUtils.UTCDateToTimestamp(date_upload_started),
    is_approved: is_approved === 1 || is_approved === 'true' || !!is_approved,
})

/**
 * Get layers array. Two places available: layer list or selected playlist's layer
 * @param {Object} state Current state
 * @param {Boolean} [inSelectedPlaylist=false] Tells if it will get the list from selected playlist
 */
const getLayersList = (state, inSelectedPlaylist = false) => {
    let layersList

    // Select layers list from last state (two places where we can get it, depending on the `inSelectedPlaylist` flag)
    if (inSelectedPlaylist) {
        // From selected playlist
        const { selected } = state
        const { playlists } = selected || {}
        const { layers: listToSelect } = playlists
        layersList = listToSelect
    } else {
        // From the layers list
        layersList = state.layers
    }

    return layersList
}

/**
 * Update layers array. Two places available: layers list or selected playlist's layers
 * @param {Object} state Current state
 * @param {Boolean} [inSelectedPlaylist=false] Tells if it will update the list from selected playlist
 */
const updateLayersList = (state, updatedList, inSelectedPlaylist = false) => {
    let newState

    // Update the state (it needs to update the same spot where it got the list)
    if (inSelectedPlaylist) {
        // state -> selected -> playlists -> layers
        newState = {
            ...state,
            selected: {
                ...state.selected,
                playlists: {
                    ...(state.selected || {}).playlists,
                    layers: updatedList,
                },
            },
        }
    } else {
        // Layers list
        newState = {
            ...state,
            layers: updatedList,
        }
    }

    return newState
}

/**
 * Updates a layer data
 * @param {Object} state Current state
 * @param {Number} layerID Layer ID
 * @param {Object} newData Object with the new date to add or update
 * @param {Boolean} [inSelectedPlaylist=false] If true, it gets layer from selected playlist.
 * If false, it gets layer from layers list
 * @returns {Object} New immutabled state
 */
const updateLayer = (state, layerID, newData, inSelectedPlaylist) => {
    // Get layers list
    const layersList = getLayersList(state, inSelectedPlaylist)

    // If the layers List was not defined, quit
    if (!layersList) {
        return state
    }

    // Get index of current element in the list
    const index = layersList.findIndex((m) => m.id === layerID)
    if (index < 0) {
        return state
    }

    // Get current element
    const selectedLayer = layersList[index]

    // Update the list
    const updatedList = ArrayUtils.insertItem(layersList, index, {
        ...selectedLayer,
        ...newData,
    })

    // Updates state
    return updateLayersList(state, updatedList, inSelectedPlaylist)
}

export { formatLayer, updateLayer }
